import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Input } from '../../index.js';
const KeyInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const [token, setToken] = useState('');
    return (React.createElement("div", null,
        React.createElement("form", { onSubmit: (e) => {
                e.preventDefault();
                e.stopPropagation();
                props.onSubmit(token);
            } },
            React.createElement("p", null, lang.login.resetTokenExplainer),
            React.createElement(Input, { placeholder: lang.login.resetTokenPlaceholder, onChange: (e) => {
                    setToken(e.target.value);
                }, value: token }),
            React.createElement(Button, { block: true, style: { marginBottom: '10px' } }, lang.misc.approve),
            React.createElement(Button, { block: true, onClick: (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    props.onCancel();
                }, theme: "secondary" }, lang.misc.cancel))));
};
export default KeyInput;
//# sourceMappingURL=TokenInput.js.map